// extracted by mini-css-extract-plugin
export default {"container":"style_container__agc4F","text":"style_text__yTbfc","circle":"style_circle__Uh4RG","rectangle":"style_rectangle__M1EAx","part":"style_part__uw+E1"};